// Features/Cart/Query.ts
var route = window.themeVariables.routes.cartUrl + ".js";
var url = new URL(route, window.location.href);
var request = new Request(url, {
  cache: "reload"
});
async function fetchCart() {
  return await fetch(request).then((response) => response.json()).then((json) => json);
}

// Features/Cart-Drawer/Analytics.ts
var Event_Cart_Open = `cart_drawer_viewed`;
async function publishCartOpen() {
  const cart = await fetchCart();
  const items = cart.items.map((item) => ({
    item_category: item.product_type,
    item_variant: item.variant_title,
    item_brand: item.vendor,
    item_name: item.product_title,
    discount: item.total_discount,
    item_id: item.sku,
    price: item.price
  }));
  const details = {
    currency: cart.currency,
    value: cart.total_price,
    items
  };
  Shopify.analytics.publish(Event_Cart_Open, details);
}

// Features/Cart-Drawer/Component.ts
import { MediaFeatures } from "Misc";
class CartDrawer extends DrawerContent {
  nextReplacementDelay = 0;
  wasEmpty = false;
  connectedCallback() {
    super.connectedCallback();
    this.wasEmpty = Boolean(this.dataset.isEmpty);
    this.rootDelegate.on(`Cart:Refresh`, this.rerenderCart.bind(this));
    this.addEventListener(`Variant:Added`, () => this.nextReplacementDelay = 600);
    this.addEventListener(`Line-Item-Quantity:Change:Start`, this.onItemsChange.bind(this));
    this.addEventListener(`Line-Item-Quantity:Change:End`, this.onItemsChanged.bind(this));
  }
  get sectionId() {
    return this.getAttribute("section");
  }
  get contentBox() {
    return this.querySelector(`.drawer__content`);
  }
  get lineItems() {
    return Array.from(this.querySelectorAll(`.line-item`));
  }
  get footerBox() {
    return this.querySelector(`.drawer__footer`);
  }
  get recommendationBox() {
    return this.querySelector(`.mini-cart__recommendations-inner`);
  }
  get checkoutButton() {
    return this.querySelector(`.checkout-button`);
  }
  async rerenderCart(event) {
    const cart = event.detail.cart;
    const isEmpty = cart ? cart.item_count === 0 : false;
    this.dataset.isEmpty = String(isEmpty);
    const sectionNames = [
      `.Cart-Header`,
      `.Cart-Freebies`,
      `.Cart-Items`,
      `.Cart-Recommendations`,
      `.Cart-Discount`,
      `.Cart-Note`,
      `.Cart-Checkout`
    ];
    const sectionList = sectionNames.map((name) => this.querySelector(name)).filter((section) => !!section).map((section) => [section.id.replace("shopify-section-", ""), section]);
    const sections = Object.fromEntries(sectionList);
    const sectionIds = Object.keys(sections);
    let updates = {};
    for (let index = 0;index < sectionIds.length; index += 5) {
      const ids = sectionIds.slice(index, index + 5);
      const endpoint = window.themeVariables.routes.cartUrl;
      const url2 = new URL(endpoint, window.location.href);
      url2.searchParams.set("sections", ids.join(","));
      const response = await fetch(url2).then((response2) => response2.json()).then((json) => json);
      updates = { ...updates, ...response };
    }
    const delay = event.detail.replacementDelay ?? this.nextReplacementDelay;
    setTimeout(async () => {
      const previousPosition = this.contentBox.scrollTop;
      for (const sectionId in updates) {
        const div = document.createElement("div");
        div.innerHTML = updates[sectionId];
        const selector = `#shopify-section-${sectionId}`;
        const { innerHTML } = div.querySelector(selector);
        sections[sectionId].innerHTML = innerHTML;
      }
      this.contentBox.scrollTop = isEmpty ? 0 : previousPosition;
      if (event.detail.openBasket)
        this.open = true;
    }, delay);
    this.nextReplacementDelay = 0;
    this.wasEmpty = isEmpty;
  }
  onItemsChange() {
    this.checkoutButton.disabled = true;
  }
  onItemsChanged(event) {
    setTimeout(() => this.checkoutButton.disabled = false, event.detail.delay);
  }
  async attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "open") {
      publishCartOpen();
      if (this.open)
        this.animateAlreadyOpen();
    }
  }
  animateAlreadyOpen() {
    this.contentBox.scrollTop = 0;
    if (MediaFeatures.prefersReducedMotion())
      return;
    const { recommendationBox, lineItems, footerBox } = this;
    const effects = [];
    if (recommendationBox && window.matchMedia(window.themeVariables.breakpoints.pocket).matches)
      lineItems.push(recommendationBox);
    lineItems.forEach((item) => item.style.opacity = String(0));
    if (recommendationBox)
      recommendationBox.style.opacity = String(0);
    if (footerBox)
      footerBox.style.opacity = String(0);
    effects.push(new ParallelEffect(lineItems.map((item, index) => new CustomKeyframeEffect(item, {
      opacity: [0, 1],
      transform: ["translateX(40px)", "translateX(0)"]
    }, {
      duration: 400,
      delay: 400 + 120 * index - Math.min(2 * index * index, 120 * index),
      easing: "cubic-bezier(0.25, 1, 0.5, 1)"
    }))));
    if (footerBox)
      effects.push(new CustomKeyframeEffect(footerBox, {
        opacity: [0, 1],
        transform: ["translateY(100%)", "translateY(0)"]
      }, {
        duration: 300,
        delay: 400,
        easing: "cubic-bezier(0.25, 1, 0.5, 1)"
      }));
    if (recommendationBox && !window.matchMedia(window.themeVariables.breakpoints.pocket).matches)
      effects.push(new CustomKeyframeEffect(recommendationBox, {
        opacity: [0, 1],
        transform: ["translateX(100%)", "translateX(0)"]
      }, {
        duration: 250,
        delay: 400 + Math.max(120 * lineItems.length - 25 * lineItems.length, 25),
        easing: "cubic-bezier(0.25, 1, 0.5, 1)"
      }));
    const animation = new CustomAnimation(new ParallelEffect(effects));
    animation.play();
  }
}

// Features/Cart-Drawer/mod.ts
window.customElements.define("cart-drawer", CartDrawer);
